export enum SRStatus {
  DRAFT = 'DRAFT',
  IMPORTED = 'IMPORTED',
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
  GENERATING_FROM_DOC = 'GENERATING_FROM_DOC',
  
}
